module.exports = __webpack_public_path__ + "static/hero-border-red-00b3d5bc32afeb7698367ebae031f31a.svg";